document.addEventListener('DOMContentLoaded', function() {
  if (window.jQuery && $('.image-carousel.owl-carousel').length) {
    $('.image-carousel.owl-carousel').owlCarousel({
      loop: true,
      margin: 10,
      nav: false,
      dots: true,
      autoplay: false,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      responsive: {
        0: { items: 1 },
        768: { items: 2 },
        1024: { items: 2 }
      }
    });
  }  

 var $carousel = $('.testimonial-list.custom-owl-carousel');
  var initialized = false;

  function handleCarousel() {
    if (window.innerWidth >= 768) {
      if (!initialized && window.jQuery && $carousel.length) {
        $carousel.owlCarousel({
          loop: true,
          margin: 10,
          nav: false,
          dots: true,
          autoplay: false,
          autoplayTimeout: 3000,
          autoplayHoverPause: true,
          responsive: {
            768: { items: 2 },
            1024: { items: 3 },
            1224: { items: 4 }
          }
        });
        initialized = true;
      }
    } else {
      if (initialized) {
        $carousel.trigger('destroy.owl.carousel');
        $carousel.removeClass('owl-loaded');
        $carousel.find('.owl-stage-outer').children().unwrap();
        initialized = false;
      }
    }
  }

  $(document).ready(handleCarousel);
  $(window).on('resize orientationchange', handleCarousel);

const dateSpan = document.querySelector('#delivery-date .date');
    const today = new Date();
    today.setDate(today.getDate() + 7);
    const options = { month: 'short', day: 'numeric' };
    const deliveryDate = today.toLocaleDateString('en-US', options);
    dateSpan.textContent = deliveryDate;
});